'use client';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { SITE } from '@/app/constants';
import { useCopy } from '@/app/hooks';
import { cn } from '@/app/utils';

interface ContactInfoProps {
  className?: string;
}

/**
 * "需要帮助"场景下的联系方式文案。国内站展示邮箱 + 可复制的官方微信号；
 * 海外站展示邮箱（通过 i18n rich text 注入 mailto:）。
 * 同时被页面底部 `Help` 与浮动入口 `HelpFloatButton` 复用，避免两份硬编码。
 */
export const ContactInfo: FC<ContactInfoProps> = ({ className }) => {
  const t = useTranslations();
  const { copy } = useCopy();

  return (
    <div className={cn('flex gap-2 text-sm sm:flex-col sm:gap-0 sm:text-center', className)}>
      {SITE === 'china' ? (
        <div>
          请联系
          <a className="text-[#0063FF]" href="mailto:support@vidu.cn">
            support@vidu.cn
          </a>
          或官方微信号：
          <span
            className="cursor-pointer text-[#0063FF]"
            onClick={() => {
              copy('Viduforhuman');
            }}
          >
            Viduforhuman
          </span>
        </div>
      ) : (
        <div>
          {t.rich('payments.mySubscription.renderHelp', {
            span: (chunks) => (
              <a className="text-[#0063FF]" href="mailto:support@vidu.com">
                {chunks}
              </a>
            ),
          })}
        </div>
      )}
    </div>
  );
};
